import { baseApi } from '@/v2/utils/api'
import { xDraw } from '@/utils/draw.js'
import studentStatusEnum from './enums/studentStatusEnum'
import exam_enum from './exam_enum'
import AliOSS from 'ali-oss'

// 多科科目集合
var multipleSubjectList = {
  'PRIMARY': ['1', '2', '3', '7', '10', '12'],
  'JUNIOR_MIDDLE': ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '12'],
  'SENIOR_MIDDLE': ['1', '2', '3', '4', '5', '6', '7', '8', '9', '12', '21'],
  'SECONDARY_VOCATIONAL': ['1', '2', '3', '4', '5', '6', '7', '8', '9', '12', '21'],
}

export const networkData = {
  ossClient: null,
  initAliClient,
  // 将抽样复评数据构造成和带批阅的数据结构一样
  getTodoQuestions2: (list) => {
    const toDoQuestions = []
    for (let cIndex = 0; cIndex < list.length; cIndex++) {
      const ques = list[cIndex];
      setQuesImages(ques.ossUrl, ques)
      // 初始化每个题待打分数集合
      ques.scores = []
      const fullScore = ques.point
      for (let sIndex = 1; sIndex <= fullScore; sIndex++) {
        ques.scores.push(sIndex)
      }
      ques.stand = { point: fullScore }
      ques.gradingTodo = { score: ques.score, resultId: ques.resultId }
    }
    return toDoQuestions
  },
  getRoleMenus: body => {
    const dict = {
      FIRST: '正常卷批阅',
      SECOND: '仲裁卷评阅',
      THIRD: '三评',
      LEADER: '异常卷批阅'
    }
    const list = []
    const keys = Object.keys(dict)
    for (let index = 0; index < body.length; index++) {
      const { judgeType, readSize } = body[index];
      const item = { list: [] }
      item.id = keys.indexOf(judgeType) + 1
      item.label = dict[judgeType]
      item.size = readSize
      item.type = judgeType
      list.push(item)
    }
    return list
  },
  setExamMarkVos: async function (params, ques) {
    // 放在此位置，及时获取当前题目的给分情况，避免异步接口冲掉
    const showScore = ques.gradingTodo.score
    ques.examMarkVos = []
    await initAliClient()
    for (let index = 0; index < ques.images.length; index++) {
      const img = ques.images[index];
      // 剔除标记格式
      const scores = img.scores.filter(item => !item.jsonUrl)
      let isRight = 0
      for (let cIndex = 0; cIndex < scores.length; cIndex++) {
        const score = scores[cIndex];
        const item = {
          showScore: score.value,
          isRight: score.type === 'add' ? 1 : 0,
          position: parseFloat(score.style.left) + ',' + parseFloat(score.style.top),
          noteIndex: index,
          pageIndex: img.pageIndex
        }
        isRight = item.isRight
        ques.examMarkVos.push(item)
      }
      // 增加批注信息
      const itemCanvas = await getItemCanvas(img, params, index)
      if (itemCanvas) {
        // 第一个图层，并且没有打标记的情况，挂载上打的分值
        if (index === 0 && scores.length === 0) {
          itemCanvas.showScore = showScore
        }
        itemCanvas.isRight = isRight
        ques.examMarkVos.push(itemCanvas)
      }
    }
  },
  setImageMarks,
  setQuesImages,
  getGradingType,
  getIdentifyStudents: (list) => {
    const students = []
    list.forEach(element => {
      let student = {
        id: '',
        resultId: '',
        className: '',
        studNo: '',
        examNo: '',
        studName: '',
        totScore: 0,
        objScore: 0,
        subScore: 0,
        status: 0,
        wayFlag: null,
        amentiaFlag: 0,
        ossUrl: '',
        flag: null,
        amentiaReason: element.amentiaReason
      }
      if (element.studentVo) {
        student.id = element.studentVo.id
        student.className = element.studentVo.className
        student.studNo = element.studentVo.seatNo
        student.examNo = element.studentVo.examNo
        student.studName = element.studentVo.studName
      }

      if (element.examResult) {
        student.resultId = element.examResult.id
        student.flag = element.examResult.flag
        student.amentiaFlag = element.examResult.amentiaFlag
        student.wayFlag = element.examResult.wayFlag
        student.ossUrl = element.examResult.ossUrl
        student.totScore = element.examResult.totScore
        student.objScore = element.examResult.objScore
        student.subScore = element.examResult.subScore
        student.examId = element.examResult.examId
        student.status = 1
      }
      students.push(student)
    });
    return students
  },
  getExamPaperDetails: (body) => {
    const details = []
    const examResult = body.examResult
    const amentiaReason = body.amentiaReason
    body.gradingStudentDetails.forEach(item => {
      let detail = {
        choiceType: exam_enum.getCodeByKey(item.choiceType), // 试题类型
        bigNum: item.bigName,
        smallNum: item.smallName,
        ossUrl: item.ossUrl,
        url: examResult ? examResult.ossUrl : '',
        num: item.num + '',
        score: item.score, // 计算得分
        point: item.maxScore, // 满分
        maxScore: item.maxScore, // 最大分
        halfPoint: item.halfScore, // 选不全得分
        type: item.type,
        standAnswer: item.standAnswer, // 标准答案
        answer: item.answer, // 学生答案
        batchTeacherName: item.gradingTeacherNames.toString(), // 批阅教师
        halfChoiceType: body.halfChoiceType,
        halfChoiceParam: item.halfChoiceJson ? JSON.parse(item.halfChoiceJson) : null, // 选项得分组合
        optionNumInit: item.optionNumInit, // 选项数量
        optionPositions: item.optionPositions, // 选项坐标集合
        multiChooseScoringPolicy: item.multiChooseScoringPolicy, // 多选题型得分
      }
      details.push(detail)
    })
    return { details, examResult, amentiaReason }
  },
  getCheckTip: function (body) {
    switch (body.state) {
      case 'STAND_UNCONFIRMED':
        return {
          message: '答案未确认',
          detail: `答案未确认，请确认答案后再结束考试`
        }
        break;
      case 'DOUBT_PAPER_UNFINISHED':
        return {
          message: '有未处理完成的疑问项',
          detail: `疑问项未处理数：<span style="color:#F56C6C">${body.doubtPaperCount}</span><br />
          还有未处理完成的疑问项，处理完成后尝试再分配批阅。`
        }
        break;
      case 'ALLOCATION_UNFINISHED':
        return {
          message: '有未分配的试题',
          detail: `标准答案数：<span style="color:#F56C6C">${body.standCount}</span>，批阅任务数：<span style="color:#F56C6C">${body.gradingTaskCount}</span><br />
          还有未分配的试题，请尝试点击重新分配后再继续。`
        }
        break;
      case 'JUDGE_UNFINISHED':
        return {
          message: '仲裁卷未批阅完成',
          detail: `仲裁批阅剩余试题数：<span style="color:#F56C6C">${body.judgeRemainCount}</span><br />
          仲裁卷未批阅完成，请仲裁老师批阅完成后再尝试结束批阅。`
        }
        break;
      case 'DOUBT_GRADING_UNFINISHED':
        return {
          message: '疑问卷未批阅完成',
          detail: `异常卷批阅剩余试题数：<span style="color:#F56C6C">${body.doubtGradingRemainCount}</span><br />
          疑问卷未批阅完成，请阅卷组长批阅完成后再尝试结束批阅。`
        }
        break;
      case 'GRADING_UNFINISHED':
        return {
          message: '试题未批阅完成',
          detail: `批阅试题分配总数：<span style="color:#F56C6C">${body.assignTotalCount}</span>，已批阅完成试题总数：<span style="color:#F56C6C">${body.gradingDetailCount}</span><br />
          考卷上传识别数量与批阅任务分配不一致，可以尝试手动分配后继续批阅，待批阅完成后再尝试结束批阅。`
        }
        break;
      case 'GRADING_STREAM_UNFINISHED':
        const list = []
        for (let index = 0; index < body.gradingStreamRemains.length; index++) {
          const element = body.gradingStreamRemains[index];
          list.push('题目' + element.name + '，<span style="color:#F56C6C">剩余数：' + element.value + '</span>')
        }
        return {
          message: '批阅流中有未批阅完成的试题',
          detail: `批阅流中有未批阅完成的试题，请尝试进入批阅继续批阅，批阅完成后再结束批阅。<br />
          未批阅完成的试题集合：${list.join('、')}`
        }
        break;
      default:
        return {
          message: '批阅未完成',
          detail: `请联系管理员`
        }
        break;
    }
  },
  // 转换识别标签数据
  convertIdentificationTabData: (body) => {
    const tabs = []
    const names = [studentStatusEnum.UN_UPLOAD_HAS_CHOOSE_SUBJECT.code, studentStatusEnum.UPLOAD_NOT_CHOOSE_SUBJECT.code]
    tabs.push(...body.filter(item => names.indexOf(item.code) < 0))
    tabs.splice(3, 0, ...body.filter(item => names.indexOf(item.code) >= 0))
    return tabs
  },
  // 返回历史数据科目集合
  getTodoSubjects (subjectList, isFilter) {
    const resp = {
      code: 200,
      result: { school_dic: {}, main: [] }
    }
    if (subjectList.length > 0) {
      let list = subjectList
      if (isFilter) {
        const stage = list[0].stage
        if (stage !== 'SECONDARY_VOCATIONAL') {
          list = list.filter(item => multipleSubjectList[stage].indexOf(item.subjectId + '') > -1)
        }
      }

      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        resp.result.main.push(element.id)
        resp.result.school_dic[element.id] = {
          subjectId: element.subjectId,
          dicCode: element.id,
          dicName: element.shortName
        }
      }
    }

    return resp
  },
  getScoreSpread (resp) {
    const obj = {
      code: 200,
      result: {
        date: Date.now(),
        distribution_curve: [],
        distribution_table: [],
        score_group: []
      }
    }
    if (resp.body && resp.body.length) {
      const all = resp.body[0]
      for (let index = 0; index < all.scoreScopes.length; index++) {
        const element = all.scoreScopes[index];
        obj.result.distribution_curve.push({ count: element.count, group: [element.start, element.end] })
        obj.result.score_group.push([element.start, element.end])
      }
      for (let index = 0; index < resp.body.length; index++) {
        const element = resp.body[index];
        element.counts = []
        for (let cIndex = 0; cIndex < element.scoreScopes.length; cIndex++) {
          const child = element.scoreScopes[cIndex];
          element.counts.push(child.count)
        }
        obj.result.distribution_table.push(element)
      }
    }
    return obj
  },
  // 获取阅卷质量
  getReadQuality (resp) {
    const obj = {
      code: 200,
      result: {
        date: Date.now(),
        avgChart: {},
        statisticsTable: {
          statisticsRows: []
        },
      }
    }
    if (resp.body && resp.body.length) {
      // 教师名称分组添加进 avgChart teacherId='--' 为总数
      // 图表信息
      const summary = resp.body.find(s => s.teacherId === '--')
      obj.result.avgChart.avgScore = summary ? summary.avgScore : 0
      const teacherScore = []
      const statisticsRows = resp.body.filter(s => s.teacherId != '--')
      statisticsRows.forEach(teacher => {
        teacherScore.push({
          teacherId: teacher.teacherId,
          teacherName: teacher.teacherName,
          avgScore: teacher.avgScore,
        })

        let row = teacher
        row.teacherType = getGradingType(teacher.teacherType)
        row.alreadyCount = teacher.readOverCount
        row.totalCount = teacher.assignCount
        row.avgGradingTime = teacher.gradingTime
        obj.result.statisticsTable.statisticsRows.push(row)
      });

      obj.result.avgChart.teacherScore = teacherScore
    }

    return obj
  },
  // 转换班级数据
  convertClassInfo (list) {
    list.forEach(item => {
      item.classId = item.orgId
      item.className = item.orgName
    })
  },
  formatTeachers (teachers) {
    return teachers.map(s => {
      return {
        teacherId: s.id,
        teacherName: s.nickName,
        ...s
      };
    });
  }
}

function setQuesImages (ossUrl, ques) {
  if (!ques.examMarkVos) {
    ques.examMarkVos = []
  }
  ques.images = []
  const list = (ossUrl || '').split(";")
  for (let index = 0; index < list.length; index++) {
    const url = list[index];
    const item = {
      rawWidth: 200,
      rawHeight: 200,
      src: url,
      scores: [] // 收集每张图被标记过的分数
    }
    if (url.indexOf('/crop,') === -1) continue
    const params = url.split("/crop,")[1].split(",");
    const key1s = ['rawWidth', 'rawHeight', 'rawX', 'rawY']
    const key2s = ['w_', 'h_', 'x_', 'y_']
    for (let index = 0; index < key2s.length; index++) {
      const element = key2s[index];
      const info = params.find(p => p.indexOf(element) === 0)
      if (info) {
        item[key1s[index]] = parseFloat(info.split("_")[1])
      } else {
        item[key1s[index]] = 0
      }
    }
    ques.images.push(item)
  }
  setImageMarks(ques, ques.examMarkVos)
}

function setImageMarks (ques, examMarkVos) {
  for (let index = 0; index < ques.images.length; index++) {
    const item = ques.images[index];
    item.scores = []
    // 恢复read页面需要的标记数据结构
    const marks = examMarkVos.filter(item => item.noteIndex === index)
    for (let mIndex = 0; mIndex < marks.length; mIndex++) {
      const mark = marks[mIndex];
      const positions = mark.position.split(',')
      if (positions.length === 2) {
        const score = {
          value: mark.showScore,
          style: {
            left: positions[0] + 'px',
            top: positions[1] + 'px',
          },
          jsonUrl: mark.writingJsonUrl,
          svgUrl: mark.writingSvgUrl,
        }
        // 生成标记分画布对象Id，这里剔除整个图层记录
        if (!score.jsonUrl) {
          if (mark.isRight) {
            score.type = 'add'
            score.id = `score_plus_${Math.round(positions[0])}_${Math.round(positions[1])}`
          } else {
            score.type = 'del'
            score.id = `score_minus_${Math.round(positions[0])}_${Math.round(positions[1])}`
          }
        }
        item.scores.push(score)
      }
    }
  }
}

async function getItemCanvas (img, params, index) {
  if (img.canvas && networkData.ossClient) {
    xDraw.exportFile(img)
    // 上传文件
    if (img.svgFile) {
      const item = {
        showScore: 0,
        isRight: 0,
        position: '0,0',
        noteIndex: index,
        pageIndex: img.pageIndex,
      }
      const nowdate = new Date()
      const year = nowdate.getFullYear();
      const month = (nowdate.getMonth() + 1).toString().padStart(2, '0');
      const fileName = `/exam/mark/${year}${month}/${params.examId}/pizhu/${params.gradingType}_${params.teacherId}_${params.detailId}_${img.pageIndex}_${index}`
      item.writingSvgUrl = await uploadFile(fileName + '.svg', img.svgFile)
      item.writingJsonUrl = await uploadFile(fileName + '.json', img.jsonFile)
      return item
    }
  }
  return null
}

async function initAliClient () {
  if (!networkData.ossClient) {
    const opt = await baseApi.getSTSToken()
    networkData.ossClient = new AliOSS(opt)
  }
}

async function uploadFile (fileName, file) {
  window.SlsSend({
    action: 'uploadFile',
    desc: '上传批注文件前',
    data: {
      fileName
    }
  })
  const result = await networkData.ossClient.multipartUpload(fileName, file)
  window.SlsSend({
    action: 'uploadFile',
    desc: '上传批注文件后',
    data: {
      result: result || {}
    }
  })
  if (result.res) {
    const urls = result.res.requestUrls
    if (urls && urls.length > 0) {
      const url = (urls[0]).split('?')[0]
      return url
    }
  } else {
    return String(result)
  }
}

function getGradingType (type) {
  const markTypeDict = {
    FIRST: '1',
    SECOND: '2',
    THIRD: '3',
    LEADER: '4'
  }

  return markTypeDict[type]
}